module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Términos y Condiciones",
      "visible": _vm.centerDialogVisible,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v("Acepto los términos y condiciones del sitio")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v("\n      Acepto el "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("código de ética")]), _vm._v(" para proveedores de contreras.\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    staticStyle: {
      "position": "relative",
      "left": "45%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("Aceptar")])])])]), _vm._v(" "), (!_vm.paramError) ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Pedido de usuario nuevo del Portal")]) : _vm._e(), _vm._v(" "), (!_vm.paramError) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v(" Para solicitar un usuario nuevo del portal, es necesario validar su identidad y la de su empresa. Por favor complete los siguientes datos:")]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.paramError))])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "ui form solicitudForm",
    attrs: {
      "id": "formSolicitud"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitFormSolicitud()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-6 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('masked-input', {
    attrs: {
      "mask": _vm.cuitMask,
      "guide": false,
      "placeholder": "",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.rut),
      callback: function($$v) {
        _vm.rut = $$v
      },
      expression: "rut"
    }
  }), _vm._v(" "), _c('label', [_vm._v("CUIT de la compañia")])], 1)])]), _vm._v(" "), (!_vm.paramInvoices) ? _c('h4', [_vm._v("Datos últimas 3 facturas")]) : _vm._e(), _vm._v(" "), (!_vm.paramInvoices) ? _c('div', {
    staticClass: "row entradas"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(2), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.invoiceMask,
      "guide": false,
      "name": "invoice0",
      "placeholder": "Nro factura 1",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.invoice0),
      callback: function($$v) {
        _vm.invoice0 = $$v
      },
      expression: "invoice0"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date0),
      expression: "date0"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "date",
      "format": "DDMMYYYY",
      "name": "date0",
      "id": "date0",
      "required": ""
    },
    domProps: {
      "value": (_vm.date0)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date0 = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.paramInvoices) ? _c('div', {
    staticClass: "row entradas"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(4), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.invoiceMask,
      "guide": false,
      "name": "invoice1",
      "placeholder": "Nro factura 2",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.invoice1),
      callback: function($$v) {
        _vm.invoice1 = $$v
      },
      expression: "invoice1"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date1),
      expression: "date1"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "date",
      "format": "DDMMYYYY",
      "name": "date1",
      "id": "date1",
      "required": ""
    },
    domProps: {
      "value": (_vm.date1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date1 = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.paramInvoices) ? _c('div', {
    staticClass: "row entradas"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(6), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.invoiceMask,
      "guide": false,
      "name": "invoice2",
      "placeholder": "Nro factura 3",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.invoice2),
      callback: function($$v) {
        _vm.invoice2 = $$v
      },
      expression: "invoice2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date2),
      expression: "date2"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "date",
      "format": "DDMMYYYY",
      "name": "date2",
      "id": "date2",
      "required": ""
    },
    domProps: {
      "value": (_vm.date2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date2 = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Nombre y Apellido")]), _vm._v(" "), _c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "placeholder": "Nombre y Apellido",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Motivo ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "reason",
      "placeholder": "Motivo del pedido de alta de usuario",
      "type": "text"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Correo electrónico ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Correo electrónico",
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group entradas_min"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.siteKey,
      "loadRecaptchaScript": true
    },
    on: {
      "verify": function($event) {
        return _vm.captchaVerificado()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": !_vm.captcha
    }
  }, [_vm._v(" Enviar solicitud")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e()])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos de la Compañia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fas fa-sort-numeric-asc",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "far fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "far fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ec92c98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Solicitud.vue
// module id = 636
// module chunks = 1